import { b as BYTES_IN_KB, c as BYTES_IN_MB } from '../constants-BPNgncOf.js';

function formatBytes(bytes) {
  if (bytes < BYTES_IN_KB) {
    return `${bytes}B`;
  }
  if (bytes < BYTES_IN_MB) {
    return `${Math.round(bytes / BYTES_IN_KB)}KB`;
  }
  return `${Math.round(bytes / BYTES_IN_MB)}MB`;
}

export { formatBytes as f };
//# sourceMappingURL=formatBytes-DScrFC7W.js.map
